<!--
 * @Descripttion: 
 * @Date: 2021-06-15 14:15:25
 * @LastEditors: Sima thief
 * @LastEditTime: 2021-06-23 16:04:57
 * @Author: Sima thief
-->
<template>
  <div class="page">
    <el-upload
      class="upload-demo"
      drag
      action="https://jsonplaceholder.typicode.com/posts/"
      multiple
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <!-- <div class="el-upload__tip" slot="tip">
        只能上传jpg/png文件，且不超过500kb
      </div> -->
    </el-upload>
    <div class="footer">
        
    </div>
    

    
  </div>
</template>
  
<script>
export default {
  name: "OrderImport",
};
</script>
  
<style lang="scss" scoped>
.page /deep/ .el-upload {
   width: 100%;
}
.page /deep/ .el-upload-dragger{
    margin: 0 auto;
}
</style>


// WEBPACK FOOTER //
// src/components/mainOrders/components/OrderImport.vue